import BasicContentComplexStatStack from './BasicContentComplexStatStack';

export { type BasicContentComplexStatStackProps } from './BasicContentComplexStatStack';
export default BasicContentComplexStatStack;
